// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// Import your components
import HomePage from './pages/HomePage'; // Make sure to create this component
import AboutPage from './pages/AboutPage'; 
import ServicePage from './pages/ServicePage';
import CareerPage from './pages/CarrerPage';
import ContactPage from './pages/ContactPage';
import GlobalSoftware from './pages/GlobalSoftware';
import NotFoundPage from "./pages/NotFoundPage";
function App() {
  return (
    <Router>
      <Routes>
        {/* Define the route for the home page */}
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicePage />} />
        <Route path="/career" element={<CareerPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/global-software-services" element={<GlobalSoftware />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
